import { mapGetters } from 'vuex';

export default {
  name: 'EmailSubscribe',
  data() {
    return {
      headerDetailsHtml: '',
      productSignupId: 'productSignup',
    };
  },
  props: {
    productHeaderDetails: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      partNumber: 'getPartNumber',
    }),
  },
  mounted() {
    this.setHeaderDetails();
  },
  watch: {
    partNumber() {
      this.setHeaderDetails();
    },
  },
  methods: {
    setHeaderDetails() {
      // set up product email script
      this.filterAndMountEmailScript();
      this.setHeaderDetailsHtml();
    },
    setHeaderDetailsHtml() {
      // create temp dom element to manipulate html
      const container = document.createElement('div');
      container.innerHTML = this.productHeaderDetails;
      const productSignupEl = container.querySelector(`#${this.productSignupId}`);

      // remove current product signup script because we'll be re-adding it later so it fires
      // If we don't re-add it, it won't run on each product switch
      if (productSignupEl) productSignupEl.parentNode.removeChild(productSignupEl);

      // set the new header details html with script removed
      this.headerDetailsHtml = container.innerHTML;
    },
    filterAndMountEmailScript() {
      // Use regex to grab the value
      const script = new RegExp('src="(.*?)"').exec(this.productHeaderDetails);
      if (!script) return;
      const { scriptHolder } = this.$refs;
      const scriptSrc = script[1];

      const scriptEl = document.createElement('script');
      scriptEl.setAttribute('src', scriptSrc);
      scriptEl.setAttribute('id', this.productSignupId);
      scriptHolder.innerHTML = '';

      // re-add product signup script
      scriptHolder.appendChild(scriptEl);
    },
  },
};
